import request, { PaginationOptions } from './request';
import deserialize from './deserialize';

export type Store = {
  id: string;
  name: string;
  address: string;
  phone: string;
  pin: string;
  neighborhood: string;
  coords: {
    lat: number;
    lng: number;
  };
};

export function list(companyId: string, opts?: PaginationOptions) {
  let url = `companion/v1/companies/${companyId}/stores`;
  if (opts) {
    const params = new URLSearchParams({
      page: opts.page.toString(),
      per: opts.per.toString(),
    });

    url = `${url}?${params.toString()}`;
  }

  return request<Store[]>({
    url,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function get(companyId: string, storeId: string) {
  return request<Store>({
    url: `/companion/v1/companies/${companyId}/stores/${storeId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
